export default "__VITE_ASSET__qPBrwIFy__"